import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MweConstants } from 'src/app/constants/mwe-constants.service';
import { EndCustomerService } from 'src/app/services/end-customer.service';

@Component({
  selector: 'app-specialitiess',
  templateUrl: './specialities.component.html',
  styleUrls: ['./specialities.component.scss']
})
export class SpecialitiesComponent implements OnInit {

  @Input() specialityForm!: FormGroup;
  @Input() endCustomerData: any;

  @Output() onUpdate: EventEmitter<any> = new EventEmitter();

  specialisations: any[] = [];
  filteredSpecialities: any[] = [];
  specialityData: any[] = [];

  showEditForm: boolean = false;
  copySpecilitySetForm: any;

  noRecordsFoundData: boolean = false;
  isSpecialityInputFieldClicked: boolean = false;

  constructor(private endCustomerService: EndCustomerService) { }

  ngOnInit(): void {
    this.getSpecialities();

    if (this.endCustomerData?.specialityInfos?.length > 0) {
      const selectedSpecialityIds = this.endCustomerData.specialityInfos.map((info: any) => info.specialityInfoId);
      this.specialityForm.get('specialityInfos')?.patchValue(selectedSpecialityIds);
      this.getSpecialityData();
    }
  }

  getSpecialities() {
    this.endCustomerService.executeGetRequestURL(MweConstants.specialtyUrl, null).subscribe(data => {
      if (data?.data?.length > 0) {
        this.specialisations = data.data.sort((a: any, b: any) => a.name.localeCompare(b.name));
        this.filteredSpecialities = this.specialisations;
        this.getSpecialityData();
      }
    });
  }

  filterSpecialities(event: any) {
    this.isSpecialityInputFieldClicked = true;
    const searchText = event.target.value.toLowerCase();
    this.filteredSpecialities = this.specialisations.filter((spec: any) =>
      spec.name.toLowerCase().includes(searchText)
    );
    this.noRecordsFoundData = this.filteredSpecialities.length === 0;
  }

  specialitiesInputFieldClicked() {
    this.isSpecialityInputFieldClicked = true;
    this.noRecordsFoundData = this.filteredSpecialities.length === 0;
  }

  specialisationSelected(specialisation: any) {
    const specialityControl = this.specialityForm.get('specialityInfos')?.value || [];
    if (specialityControl.includes(specialisation.id)) {
      this.specialityForm.get('specialityInfos')?.patchValue(specialityControl.filter((id: any) => id !== specialisation.id));
    } else {
      specialityControl.push(specialisation.id);
      this.specialityForm.get('specialityInfos')?.patchValue(specialityControl);
    }
  }

  remove(i: number): void {
    this.specialityForm.get('specialityInfos')?.value.splice(i, 1);
    this.specialityForm.get('specialityInfos')?.patchValue(this.specialityForm.get('specialityInfos')?.value);
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event) {
    const targetElement = event.target as HTMLElement;
    const formFieldElement = document.querySelector('.skillSetDopdownContainer');
    if (formFieldElement?.contains(targetElement)) return;
    this.isSpecialityInputFieldClicked = false;
  }

  update() {
    this.onUpdate.emit(10);
    this.refresh();
  }

  cancel() {
    this.showEditForm = false;
  }

  editSpeciality() {
    this.copySpecilitySetForm = JSON.parse(JSON.stringify(this.specialityForm.value));
    this.showEditForm = true;
  }

  refresh() {
    this.showEditForm = false;
    this.getSpecialityData();
  }

  getSpecility(id: any) {
    return this.specialisations.find((obj: any) => obj?.id === id)?.name;
  }

  getSpecialityData() {
    const speciality = this.specialisations;
    const specialityInfos = speciality.filter((obj1: any) => {
      return this.specialityForm.get('specialityInfos')?.value.some((obj2: any) => obj1.id === obj2);
    });
    this.specialityData = specialityInfos;
  }
}
